import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel", "related"]

  switchTab(event) {
    if (event.currentTarget.tagName === "BUTTON") {
      event.preventDefault()
    }

    const selectedIndex = this.tabTargets.indexOf(event.currentTarget)

    this.tabTargets.forEach((node, index) => {
      node.classList.toggle("active", index === selectedIndex)
    })

    this.panelTargets.forEach((node, index) => {
      const isActive = index === selectedIndex
      node.classList.toggle("hidden", !isActive)

      if (isActive) {
        node.dataset.active = "true"
        this.triggerTextareaResize(node)
      } else {
        node.removeAttribute("data-active")
      }
    })

    this.relatedTargets.forEach((element, index) => {
      const isActive = index === selectedIndex
      element.classList.toggle("hidden", !isActive)
    })

    const customEvent = new CustomEvent("tab:changed", {
      bubbles: true,
      detail: { selectedIndex }
    })
    document.dispatchEvent(customEvent)
  }

  triggerTextareaResize(panel) {
    const textareas = panel.querySelectorAll("textarea[data-controller~='textarea-autogrow']")
    textareas.forEach(textarea => {
      textarea.dispatchEvent(new Event("input", { bubbles: true }))
    })
  }
}
